<template>
  <div class="home">
    <div ref="cursorRef" class="cursorContainer">
      <div ref="square" class="square"></div>
      <div ref="cursorDot" class="dot"></div>
    </div>
    <div class="home__js-scroll">
      <!-- Container with text and squiggle -->
      <div class="home__introContainer">
        <h1 class="home__jelani" data-splitting>Jelani Thompson</h1>
        <p
          class="home__jelaniIntro"
          data-splitting
        >Creative Technologist and Developer based in Toronto, Canada.</p>
        <svg id="home__squiggle">
          <path
            d="M28.9038 36.943C20.7486 23.0632 13.8437 11.6948 0 11.6948L0 0.871796C8.48579 0.871796 15.0049 4.31428 20.3453 9.34905C35.7104 23.8345 42.5483 55.5335 64.2331 55.5335C78.0769 55.5335 84.9818 44.1651 93.1369 30.2853C93.2318 30.1237 93.327 29.9617 93.4223 29.7994C101.261 16.453 110.413 0.871796 128.466 0.871796C146.52 0.871796 155.671 16.453 163.51 29.7994C163.606 29.9617 163.701 30.1237 163.796 30.2853C171.951 44.1651 178.856 55.5335 192.699 55.5335C206.543 55.5335 213.448 44.1651 221.603 30.2853L221.889 29.7994C229.728 16.453 238.879 0.871796 256.933 0.871796C274.986 0.871796 284.138 16.4531 291.977 29.7995L292.262 30.2853C300.417 44.1651 307.322 55.5335 321.166 55.5335V66.3565C303.112 66.3565 293.961 50.7753 286.122 37.4289L285.836 36.943C277.681 23.0632 270.776 11.6948 256.933 11.6948C243.089 11.6948 236.184 23.0632 228.029 36.943L227.743 37.4289C219.904 50.7753 210.753 66.3565 192.699 66.3565C174.646 66.3565 165.494 50.7753 157.655 37.429C157.56 37.2666 157.465 37.1047 157.37 36.943C149.215 23.0632 142.31 11.6948 128.466 11.6948C114.623 11.6948 107.718 23.0632 99.5625 36.943C99.4676 37.1046 99.3725 37.2666 99.2771 37.4289C91.4381 50.7753 82.2865 66.3565 64.2331 66.3565C46.1798 66.3565 37.0282 50.7753 29.1891 37.4289C29.0938 37.2666 28.9987 37.1046 28.9038 36.943Z"
          />
        </svg>
      </div>

      <img
        class="home__arrow-down"
        src="../assets/images/arrow-down.png"
        alt="Down Arrow for next section"
        @click="this.scrollDown"
      />

      <!-- Selected Works -->
      <h3 id="selectedWorks" class="home__selectedWorks">Selected Works</h3>
      <div class="home__selectedWorksContainer">
        <!-- Contentful stuff goes in here -->
        <div class="home__contentItem" v-for="(item, index) in workArray" :key="index">
          <a :href="item.fields.link" target="_blank" class="home__contentLink">
            <!-- Source sets for conditional image serve -->
            <picture>
              <source :srcset="`${item.fields.media.fields.file.url}?fm=webp&q=80`" />
              <source :srcset="`${item.fields.media.fields.file.url}?fm=jpg&q=100`" />
              <img
                :src="`${item.fields.media.fields.file.url}?fm=webp&q=80`"
                class="home__imageItem"
              />
            </picture>
          </a>
          <a :href="item.fields.link" target="_blank" class="home__contentLink">
            <div class="home__selectedWorkTitle">{{ item.fields.name}}</div>
            <div class="home__selectedWorkTools">{{ item.fields.toolsUsed }}</div>
          </a>
        </div>
      </div>

      <!-- Welcome to my portfolio! -->

      <div class="home__welcomeSocialContainer">
        <p class="home__welcome">
          Hello there, welcome to my portfolio!
          <br />
          <br />My name’s Jelani Thompson and I’m a Creative Technologist and Developer hailing from OCAD University’s Digital Futures program.
          <br />
          <br />
          <span class="home__skillsTools">Skills and Tools:</span>
          <br />- Web + App Development (VueJS, Flutter, etc.)
          <br />- WebGL / ThreeJS + Processing / P5.js
          <br />- TouchDesigner / Nodes.io
          <br />- Visual Design / Branding + User Interface Design
          <br />- CAD (e.g. Fusion 360, Rhino) / CNC / Rapid Prototyping
          <br />- Data Visualization and Analysis
          <br />- Electronics Prototyping (Arduino) / Physical Computing
          <br />- MaxMSP + Ableton Live
          <br />- Unity
          <br />- Artificial Intelligence + Machine Learning (ML5)
          <br />
          <br />If you'd like to discuss a potential project or just want to chat, you can get in touch by using one of the social links below.
        </p>

        <div class="home__socialIcons">
          <a href="mailto:jelani@jelani.io" target="_blank">
            <img src="@/assets/images/mail.png" alt="Jelani Thompson email" class="home__email" />
          </a>
          <a href="https://twitter.com/JelaniThompson_" target="_blank">
            <img
              src="@/assets/images/Twitter_Logo_Blue.png"
              alt="Jelani Thompson Twitter"
              class="home__twitter"
              width="56px"
            />
          </a>
        </div>
      </div>

      <div class="home__educationContainer">
        <section class="flag"></section>
        <div class="home__educationTextContainer">
          <p class="home__educationText">
            <span class="home__education">Education</span>
            <br />
            <br />
            <span class="home__subMajor">Digital Futures</span>
            <br />
            <span class="home__subSchool">OCAD University (Toronto, Canada)</span>
            <br />
            <br />
            <span class="home__subMajor">Games and Interactive Media (2021)</span>
            <br />
            <span class="home__subSchool">RMIT University (Melbourne, Australia)</span>
          </p>
        </div>
      </div>
      <img src="@/assets/images/smile.png" alt="Always stay positive!" class="home__smiley" />
    </div>
  </div>
</template>

<script>
import { client } from "../contentfulConfig.js";

/* eslint-disable no-unused-vars */
import * as THREE from "../three.module.js";
// import '../flag.js';
// import LocomotiveScroll from 'locomotive-scroll';

// import { gsap } from "gsap";
import { gsap } from "gsap/dist/gsap";

import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";

// import imagesLoaded from 'vue-images-loaded'

export default {
  name: "Home",
  data() {
    return {
      workArray: [],
      scroller: null,
    };
  },
  beforeMount() {
    this.getSelectedWorks();
  },
  mounted() {
    this.makeWaves();
    this.loadThree();
    Splitting();

    // this.getSelectedWorks();
    // this.scroller = new LocomotiveScroll({
    //   el: document.querySelector('[-container]'),
    //   smooth: true,
    //   smoothMobile: false,
    //   getDirection: false,
    //   getSpeed: false,
    //   // scrollFromAnywhere: true
    // });

    // this.scroller.init()

    let X = 0;
    let Y = 0;

    const timelineSettings = {
      staggerValue: 0.05,
      charsDuration: 1.1,
    };

    let cursor = document.querySelector(".dot");
    const { cursorRef, cursorDot, square } = this.$refs;

    let DOMdata = {
      content: {
        home: {
          // Get access to characters inside of the intro container
          section: document.querySelector(".home__introContainer"), //__introContainer before
          get chars() {
            return this.section.querySelectorAll(".home__jelani .word > .char"); // and .home__gsap
          },
          isVisible: true, // False by default so that we can trigger the appear animation
        },
        description: {
          section: document.querySelector(".home__introContainer"),
          get chars() {
            return this.section.querySelectorAll(
              ".home__jelaniIntro .word > .char"
            );
          },
          isVisible: true,
        },
      },
    };

    // GSAP Code from Codrops tutorial https://tympanus.net/codrops/2020/06/17/making-stagger-reveal-animations-for-text/
    const timeline = gsap
      .timeline({ paused: false })
      .addLabel("start")
      .staggerFrom(
        DOMdata.content.home.chars,
        timelineSettings.charsDuration,
        {
          ease: "Power2.easeInOut",
          y: "100%",
          x: "-30%",
        },
        timelineSettings.staggerValue,
        "start"
      )
      .staggerFrom(
        DOMdata.content.description.chars,
        timelineSettings.charsDuration,
        {
          ease: "Power2.easeInOut",
          y: "100%",
          opacity: 0,
        }
      );

    // document.addEventListener("resize", function(){ this.scroller.update(); });

    document.addEventListener("mousemove", (coords) => {
      X = coords.clientX;
      Y = coords.clientY;

      cursor.style.left = X - 10 + "px";
      cursor.style.top = Y - 10 + "px";

      gsap.to(square, 0.7, { css: { left: X - 32.5, top: Y - 32.5 } });
    });
  },

  methods: {
    makeWaves() {
      // Map our x's from 0 to our page width
      let xs = [];
      let screenWidth = window.innerWidth;
      for (let i = 0; i <= screenWidth; i++) {
        xs.push(i);
      }

      let time = 0;

      // re-calculate where the points should be every frame
      function animate() {
        let points = xs.map((x) => {
          /* Perform a sin on each y=x (0 - 800) so that they're moving every frame
              x + time is what creates the movement effect */
          let y = 60 + 20 * Math.sin((x + time) * 0.06);
          return [x, y]; // return the x axis point and its corresponding y value
        });

        // Turn it into an HTML attribute and replace the element with updated values
        let path =
          "M" +
          points
            .map((p) => {
              return p[0] + "," + p[1];
            })
            .join(" L");

        document.querySelector("path").setAttribute("d", path);

        time += 1.2;

        requestAnimationFrame(animate);
      }

      // Scroll indicator code
      let wave = document.getElementById("home__squiggle");
      wave.style.width = 750;

      animate();
    },
    getSelectedWorks() {
      client
        .getEntries({ content_type: "selectedWork", order: "fields.order" })
        .then((entries) => {
          entries.items.forEach((entry) => {
            if (entry.fields.name) {
              this.workArray.push(entry);
            }
          });
        });
      console.log(this.workArray);
    },
    loadThree() {
      const section = document.querySelector("section.flag");

      // Creating our basic scene
      var scene = new THREE.Scene();
      var camera = new THREE.PerspectiveCamera(
        75,
        section.clientWidth / section.clientHeight,
        0.1,
        1000
      );

      var renderer = new THREE.WebGLRenderer({
        alpha: true,
        antialias: true,
      });

      renderer.setSize(section.clientWidth, section.clientHeight);
      section.appendChild(renderer.domElement);

      const loader = new THREE.TextureLoader();
      const canadaFlag = require("../assets/images/canadian-flag.jpg");

      var geometry = new THREE.PlaneGeometry(5, 3, 50, 30);

      var material = new THREE.MeshBasicMaterial({
        map: loader.load(canadaFlag),
      });

      var flag = new THREE.Mesh(geometry, material);
      scene.add(flag);

      flag.rotation.set(-0.1, 0, 0);

      camera.position.z = 5;

      const clock = new THREE.Clock();

      function animate() {
        const time = clock.getElapsedTime();

        flag.geometry.vertices.map((v) => {
          const waveX1 = 0.5 * Math.sin(v.x * 2 + time);
          const waveX2 = 0.25 * Math.sin(v.x * 3 + time * 4);
          const waveY1 = 0.1 * Math.sin(v.y * 5 + time * 0.5);
          const multi = (v.x + 2.5) / 5; // Ensure that the left side of the flag doesn't move
          v.z = (waveX1 + waveX2 + waveY1) * multi;
        });

        flag.geometry.verticesNeedUpdate = true; // Listen for changes to values and reflect in the animation

        requestAnimationFrame(animate);
        renderer.render(scene, camera);
      }
      animate();

      // Responsive code
      window.addEventListener("resize", function () {
        camera.aspect = section.clientWidth / section.clientHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(section.clientWidth, section.clientHeight);
      });
    },

    scrollDown() {
      let anchor = document.querySelector(".home__selectedWorks");
      anchor.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style lang="scss">
@import "../assets/_variables.scss";

section.flag {
  width: 60vw;
  height: 90vh;
}

svg {
  top: 0;
  left: 0;
  margin-left: 0;
  position: relative;
}

path {
  stroke: #fff;
  stroke-width: 10px;
  stroke-linecap: round;
  fill: none;
}

.square {
  border: 2px solid white;
  width: 50px;
  height: 50px;
  position: fixed;
  pointer-events: none;
  transform: rotate(45deg);
  z-index: 99;
}

.dot {
  background-color: #fff;
  position: fixed;
  z-index: 99;
  border-radius: 100%;
  width: 10px;
  height: 10px;
}

.home {
  background-color: #000;
  height: 100vh;
  overflow-x: hidden;
  &__introContainer {
    max-width: 900px;
    margin-left: 6.31%;
    display: flex;
    flex-wrap: wrap;
    &:hover {
      cursor: none;
    }
  }
  &__jelani {
    // Use em to scale for responsiveness because it's based on font size
    font-size: 96px;
    font-family: "Greycliff CF 2.0";
    font-weight: $header;
    text-align: left;
    white-space: nowrap;
    margin: 174px 0 0 0;
    overflow: hidden; // Required for splitting animation
  }
  &__jelaniIntro {
    font-weight: $headerintro;
    font-size: $headerintro;
    text-align: left;
    margin-top: -7.5%;
    padding-top: 42px;
    overflow: hidden; // Also required for splitting animation
  }

  #home__squiggle {
    height: 90% !important;
    width: 90% !important;
    margin-top: -5%;
  }
  &__sun {
    position: absolute;
    margin-top: 3.86%;
    margin-right: 8.75%;
    right: 0;
  }
  &__arrow-down {
    position: sticky;
    padding: 20px;
    margin-right: 7.84%;
    margin-left: 85%;
    right: 0;
    justify-self: flex-end;
    animation: upDown 0.85s alternate infinite ease-in-out;
  }

  @keyframes upDown {
    // Sine wave animation
    to {
      transform: translatey(50px);
    }
  }

  &__selectedWorks {
    font-size: $microheader;
    margin-top: 18%;
    text-align: left;
    font-weight: $heavy;
    position: relative;
    margin-left: 6.31%;
  }
  &__selectedWorksContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    &:hover {
      cursor: none;
    }
  }

  &__contentItem {
    width: 50%;
    position: relative;
  }

  &__contentLink {
    text-decoration: none;
    color: #fff;
    &:visited {
      color: #fff;
    }
  }

  &__imageItem {
    width: 80%;
    margin: 10% 10% 0 10%;
    min-height: 360px;
    max-height: 360px;
    object-fit: cover;
    display: block;
    opacity: 1;
    transition: 0.5s ease;
    backface-visibility: hidden;
    &:before {
      background: linear-gradient(rgba(220, 220, 220, 0.7), rgba(0, 0, 0, 0.8));
      opacity: 1;
      transition: opacity 0.3s cubic-bezier(0.47, 0, 0.745, 0.715);
    }
    &:hover {
      opacity: 0.3;
      transition: 0.5s ease-in;
    }
  }

  &__selectedWorkTitle {
    font-size: $microheader;
    font-weight: $medium;
    margin-top: 10px;
  }
  &__selectedWorkTools {
    font-size: $description;
    font-weight: $extralight;
    margin-top: 12px;
  }
  &__welcomeSocialContainer {
    max-width: 945px;
    justify-self: center;
    margin: 0 auto;
    padding: 0 10% 0 10%;
  }
  &__welcome {
    margin-top: 10%;
    margin-bottom: 10%;
    text-align: left;
    max-width: 945px;
    margin-left: auto;
    margin-right: auto;
    font-size: $paragraph;
  }
  &__skillsTools {
    font-weight: $bold;
  }
  &__socialIcons {
    display: flex;
    justify-self: flex-start;
    margin-right: 100%;
    align-items: center;
    margin-top: -8%;
  }
  &__email {
    text-decoration: none;
    align-self: center;
    max-width: 30px;
    padding-right: 10px;
    object-fit: contain;
    z-index: 99;
  }
  &__educationContainer {
    display: inline-flex;
    align-items: center;
    text-align: left;
    width: 100%;
  }

  &__educationTextContainer {
    margin-right: 8.26%;
    max-width: 642px;
  }

  &__educationText {
    margin-left: -12.5%;
  }

  &__education {
    font-size: $microheader;
    font-weight: $heavy;
  }

  &__subMajor {
    font-size: $headerintro;
    font-weight: $demibold;
    text-align: left;
  }

  &__subSchool {
    font-size: $headerintro;
    font-weight: $regular;
    white-space: nowrap;
  }

  &__smiley {
    position: relative;
    bottom: 0;
    justify-self: center;
    margin-bottom: 40px;
  }

  // Small phones
  @media (max-width: 414px) {
    .cursorContainer {
      visibility: hidden;
    }

    #home__squiggle {
      height: 90% !important;
      width: 90% !important;
      margin-top: -8%;
    }

    path {
      stroke-width: 5px;
    }

    section.flag {
      margin: 0% auto 0 auto;
      width: 90vw;
    }

    // #js-scroll {
    //   height: 100vh;
    //   // min-height: 4000px;
    // }

    &__introContainer {
      margin-bottom: -70%;
    }

    &__socialIcons {
      margin-left: 0% !important;
      left: 0;
    }

    &__jelani {
      font-size: 2em !important;
      margin: 90px 0 0 0;
    }
    &__jelaniIntro {
      font-size: 1em;
      margin-top: -8%;
    }
    &__arrow-down {
      visibility: hidden;
    }

    &__selectedWorks {
      font-size: 2em;
      margin-top: 70%;
    }

    &__contentItem {
      width: 100%;
    }

    &__imageItem {
      min-height: 0px;
    }

    &__selectedWorkTitle {
      font-size: 1.5em !important;
    }

    &__selectedWorkTools {
      font-size: 1em;
    }

    &__welcome {
      font-size: 1em;
      max-width: 280px;
      margin-left: auto;
      margin-right: auto;
    }

    &__educationContainer {
      flex-wrap: wrap;
      margin-top: -30%;
      pointer-events: none;
    }

    &__educationText {
      margin-left: 0%;
    }

    &__education {
      font-size: 2em;
    }

    &__subMajor {
      font-size: 1.5em;
      word-break: break-word;
      white-space: normal;
    }

    &__subSchool {
      font-size: 1.5em;
      word-break: break-word;
      white-space: normal;
    }

    &__educationTextContainer {
      display: flex;
      justify-content: center;
      margin: -40% auto 0 auto !important;
    }

    &__educationText {
      padding: 40px;
    }
  }

  @media (min-width: 414px) and (max-width: 540px) {
    &__jelani {
      font-size: 2.8em !important;
    }
    .cursorContainer {
      visibility: hidden;
    }
    &__socialIcons {
      margin-left: 0%;
      left: 0;
    }
    &__educationText {
      margin-left: 0%;
    }
  }

  @media (min-width: 768px) {
    &__jelaniIntro {
      font-size: 2.3em !important;
      padding: 11% 0 3% 0;
    }
    &__educationContainer {
      margin-top: 0%;
    }
    &__educationTextContainer {
      margin: 0 auto 0 auto;
    }
    &__educationText {
      margin-left: 0%;
    }
  }

  // @media only screen and (max-width: 768px) {
  //   .cursorContainer {
  //     visibility: hidden;
  //   }
  // }

  @media (max-width: 768px) {
    section.flag {
      margin: 0% auto 0 auto;
      width: 90vw;
    }

    #home__squiggle {
      width: 90% !important;
      margin-top: -5%;
    }

    &__jelani {
      font-size: 5em;
      margin: 90px 0 0 0 !important;
    }
    &__jelaniIntro {
      font-size: 1.1em;
      margin-top: -5%;
      width: 90%;
    }
    &__arrow-down {
      margin-top: -15%;
      display: none;
    }
    &__contentItem {
      width: 100%;
    }
    &__selectedWorkTitle {
      font-size: 2.5em;
    }
    &__selectedWorkTools {
      font-size: 1em;
    }
    &__welcome {
      font-size: 1.5em;
      max-width: 620px;
      margin-left: auto;
      margin-right: auto;
    }

    &__educationContainer {
      flex-wrap: wrap;
      margin-top: -30%;
      pointer-events: none;
    }

    &__education {
      font-size: 2em;
    }

    &__educationTextContainer {
      display: flex;
      justify-content: center;
      margin: -40% auto 0 auto !important;
    }

    &__educationText {
      padding: 40px;
    }

    &__subMajor {
      font-size: 1.5em;
      word-break: break-word;
      white-space: normal;
    }

    &__subSchool {
      font-size: 1.5em;
      word-break: break-word;
      white-space: normal;
    }
  }

  // @media only screen and (max-width: 991.98px) {
  //   .cursorContainer {
  //     visibility: hidden;
  //   }
  // }

  // Medium-sized devices such as tablets
  @media (max-width: 991.98px) {
    section.flag {
      margin: 0% auto 0 auto;
      width: 90vw;
    }

    #home__squiggle {
      width: 90% !important;
    }

    &__jelani {
      font-size: 5em;
    }

    &__arrow-down {
      visibility: hidden;
    }

    &__contentItem {
      width: 100%;
    }

    &__welcome {
      font-size: 1.5em;
      margin-left: auto;
      margin-right: auto;
      max-width: 600px;
    }

    &__educationContainer {
      flex-wrap: wrap;
      pointer-events: none;
    }

    &__education {
      font-size: 3.5em;
    }

    &__educationTextContainer {
      display: flex;
      justify-content: center;
    }

    &__educationText {
      padding: 40px;
    }
  }

  // Large devices such as desktops
  @media (max-width: 1199.98px) {
    section.flag {
      margin: 0% auto 0 auto;
      width: 90vw;
    }

    &__contentItem {
      width: 100%;
    }

    &__arrow-down {
      visibility: hidden;
    }

    &__education {
      font-size: 3.5em;
    }

    &__educationText {
      padding: 40px;
    }
  }

  @media screen and (min-width: 1280px) and (max-width: 2560px) {
    section.flag {
      margin: 0% auto 0 auto;
      width: 90vw;
    }
    &__educationText {
      // padding: 40px;
      margin-top: -1.5%;
      margin-left: -12.5%;
    }
  }

  /* ----------- iPad Pro ----------- */
  /* Portrait and Landscape */
  @media only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    &__jelaniIntro {
      padding: 13% 0 2% 0;
      // font-size: 2.5em;
    }
    #home__squiggle {
      height: 90% !important;
      width: 90% !important;
      margin-top: -3%;
    }
    section.flag {
      margin: 5% auto 0 auto;
      width: 90vw;
      // height: auto;
    }
    &__educationTextContainer {
      display: flex;
      justify-content: center;
      margin: -35% auto 5% auto !important;
    }
    &__educationContainer {
      flex-wrap: wrap;
      margin-top: -35%;
    }
    &__contentItem {
      width: 100%;
    }
    &__arrow-down {
      visibility: hidden;
    }
  }

  /* Locomotive Scroll Stuff */
  // html.has-scroll-smooth {
  //   overflow: hidden;
  // }

  // html.has-scroll-dragging {
  //   -webkit-user-select: none;
  //   -moz-user-select: none;
  //   -ms-user-select: none;
  //   user-select: none; }

  // .has-scroll-smooth body {
  //   overflow: hidden; }

  // .has-scroll-smooth [-container] {
  //   min-height: 100vh; }

  // .c-scrollbar {
  //   position: absolute;
  //   right: 0;
  //   top: 0;
  //   width: 11px;
  //   height: 100vh;
  //   transform-origin: center right;
  //   transition: transform 0.3s, opacity 0.3s;
  //   opacity: 0; }
  //   .c-scrollbar:hover {
  //     transform: scaleX(1.45); }
  //   .c-scrollbar:hover, .has-scroll-scrolling .c-scrollbar, .has-scroll-dragging .c-scrollbar {
  //     opacity: 1; }

  // .c-scrollbar_thumb {
  //   position: absolute;
  //   top: 0;
  //   right: 0;
  //   background-color: black;
  //   opacity: 0.5;
  //   width: 7px;
  //   border-radius: 10px;
  //   margin: 2px;
  //   cursor: -webkit-grab;
  //   cursor: grab; }
  //   .has-scroll-dragging .c-scrollbar_thumb {
  //     cursor: -webkit-grabbing;
  //     cursor: grabbing; }
}
</style>